import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { finalize, Subject } from 'rxjs';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { AppFilesService } from 'src/app/services/app-files.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { NotificariService } from '../../notificari.service';
import Swal from 'sweetalert2';
import { FormGroup } from '@angular/forms';
import { NotificationService } from 'src/app/services/notification.service';


@Component({
    selector: 'app-email',
    templateUrl: './email.component.html',
    styleUrls: ['./email.component.scss']
})
export class EmailComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() searchParamsForm!: FormGroup;
    @Input() selectedStartDate!: Date;
    @Input() selectedEndDate!: Date;
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;
    dtParameters: any = {};

    isLoading = false;

    dtLink =
        environment.interop.basePath +
        environment.interop.dgaspc.notificari.email.getEmailDt;

    selectedRowIds: number[] = [];

    rowCount = 0;
    checkboxSelections = false;

    constructor(
        private http: HttpClient,
        private permissionsService: PermissionsService,
        private appFilesService: AppFilesService,
        private notificariService: NotificariService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    formatDateRender(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    renderDT() {
        const self = this;
        this.isLoading = true;

        this.dtOptions = {
            order: [[1, 'desc']],
            serverSide: true,
            searching: false,
            responsive: true,
            pageLength: 25,
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                const filters = { ...this.searchParamsForm.value };
                delete filters['telefon'];
                dataTablesParameters.filters = filters;
                dataTablesParameters.date_from = this.formatDateRender(this.selectedStartDate);
                dataTablesParameters.date_to = this.formatDateRender(this.selectedEndDate);

                this.dtParameters = dataTablesParameters;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        this.getTableRowCount();
                        this.checkboxesReset();

                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: `<input type="checkbox" class="row-checkbox" style="width: 20px; height: 20px;" id="headerCheckbox"/>`,
                    data: 'id',
                    sortable: false,
                    className: 'all',
                    render: (data: any, type: any, row: any) => {
                        return `
							<div style="display: flex; align-items: center; gap: 5px;">
								<input type="checkbox" class="row-checkbox" style="width: 20px; height: 20px;" value="${row.id}" />
							</div>
						`;
                    },
                },
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Identificare Solicitare',
                    data: 'cerere_id_public',
                    render: (data: any, type: any, row: any) => {
                        return `
                                <div style="display: flex; align-items: center; gap: 5px;">
                                    <span>${row.cerere_id_public}</span>
                                    <span>/</span>
                                    <span>${this.formatDateWithoutHour(row.created_at)}</span>
                                </div>
                                <div> <br/>
									<span  style="padding: 5px; background-color: #bdbdbd; border: 0px;border-radius:5px">I: ${row.cerere_id}</span>
								</div>
                            `;
                    },
                },
                {
                    title: 'Subiect',
                    data: 'subject',
                },
                {
                    title: 'Trimis către',
                    data: 'email_sent_to',
                    orderable: false,
                },
                {
                    title: 'Status',
                    data: 'email_status',
                    orderable: false,
                },
                {
                    title: 'Dată notificare',
                    data: 'email_date',
                    render: (data: any, type: any, row: any) => {
                        return `
                                <span>Dată trimis: ${data ? this.formatDate(data) : 'n/a'}</span>
                                <br>
                                <span><i class="fa-solid fa-gear"></i> Dată inițiere: ${row.created_at ? this.formatDate(row.created_at) : 'n/a'}</span>
                            `;
                    },
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    className: 'all',
                    orderable: false,
                    render: () => {
                        return `
			                <div class="d-flex align-center justify-content-left gap-2">
                                <button style="border: 1px solid #0044cc;" type="button" class="btn btn-light download">
                                    <img src="/assets/icons/view.svg" alt="VIZUALIZAȚI" />
                                    <span style="color: #0044cc; font-weight: 700; font-size: 12px;" class="view-btn-text">VIZUALIZAȚI</span>
                                </button>
                                <button class="action-btn edit resend">
                                    <span style="color: #fff;">RETRIMITE</span>
                                </button>
							</div>
						`;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                $('td', row).off('click');

                // Handle click event on the CHECKBOXES
                $(row)
                    .find('.row-checkbox')
                    .off('change')
                    .on('change', function () {
                        let idCerere = Number($(this).val());

                        if ($(this).is(':checked')) {
                            self.selectedRowIds.push(idCerere);
                        } else {
                            self.selectedRowIds = self.selectedRowIds.filter(
                                (id) => id !== idCerere
                            );
                        }

                        if (self.rowCount !== self.selectedRowIds.length) {
                            self.checkHeaderCheckBox(false);
                        } else if (self.rowCount === self.selectedRowIds.length) {
                            self.checkHeaderCheckBox(true);
                        }

                        self.checkboxSelections = self.selectedRowIds.length > 0;
                    });

                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const downloadButton = lastTd?.querySelector('.download') as HTMLElement;
                const resendButton = lastTd?.querySelector('.resend') as HTMLElement;

                if (downloadButton) {
                    if (
                        !this.permissionsService.hasPermission(
                            'dgaspc-module.notificari.email.view'
                        )
                    ) {
                        downloadButton.style.display = 'none';
                    }
                    downloadButton.addEventListener('click', () => {
                        const { id } = data;
                        this.downloadEmail(id);
                    });
                }

                if (resendButton) {
                    if (
                        !this.permissionsService.hasPermission(
                            'dgaspc-module.notificari.email.resend'
                        )
                    ) {
                        resendButton.style.display = 'none';
                    }
                    resendButton.addEventListener('click', () => {
                        const { id } = data;
                        this.resendEmail(id);
                    });
                }

                return row;
            },
            headerCallback: (row: Node, data: any[] | any) => {
                const headerCheckbox = $(row).find('#headerCheckbox');

                // Remove any existing event handlers to avoid duplicating them
                headerCheckbox.off('change click');

                // Handle the change event for selecting/deselecting all checkboxes
                headerCheckbox.on('change', function () {
                    if ($(this).is(':checked')) {
                        self.selectedRowIds.length = 0;
                        data.forEach((item: any) => {
                            self.selectedRowIds.push(item.id);
                        });
                        self.checkMultipleCheckboxesByValue(true);
                    } else {
                        self.selectedRowIds.length = 0;
                        self.checkMultipleCheckboxesByValue(false);
                    }
                    self.checkboxSelections = self.selectedRowIds.length > 0;
                });

                // Prevent sorting when clicking the checkbox
                headerCheckbox.on('click', function (e) {
                    e.stopPropagation();
                });

                return row;
            },
        };
    }

    async getTableRowCount() {
        const table = await this.dtElement.dtInstance;
        this.rowCount = table.rows().count();
    }

    checkHeaderCheckBox(checkValue: boolean) {
        const headerCheckbox = document.getElementById(
            'headerCheckbox'
        ) as HTMLInputElement;
        headerCheckbox.checked = checkValue;
    }

    checkMultipleCheckboxesByValue(checkValue: boolean) {
        let checkboxes = document.querySelectorAll<HTMLInputElement>(
            'input[type="checkbox"]'
        );
        checkboxes.forEach((checkbox) => {
            checkbox.checked = checkValue;
        });
    }

    checkboxesReset() {
        this.selectedRowIds.length = 0;
        this.checkMultipleCheckboxesByValue(false);
        this.checkHeaderCheckBox(false);
        this.checkboxSelections = false;
    }

    rerenderDT(paginate = false): void {
        this.isLoading = true;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.isLoading = false;
            dtInstance.draw(paginate);
        });
    }

    formatDate(input: string): string {
        const date = new Date(input);

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    }

    formatDateWithoutHour(input: string): string {
        const date = new Date(input);

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
    }

    downloadEmail(id: number) {
        let fullPath = this.notificariService.downloadEmailUrl + id;
        this.appFilesService.downloadFile(fullPath);
    }

    resendEmail(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Doriți să retrimiteți email-ul selectat?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.notificariService.resendEmail(id)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: () => {
                            Swal.fire({
                                title: helper.dialogConfig.headers.success,
                                text: 'Notificare Email trimisă cu succes.',
                                icon: 'success',
                                confirmButtonText: helper.dialogConfig.buttonLabels.close,
                                allowOutsideClick: false,
                            }).then(() => {
                                this.rerenderDT();
                            });
                        },
                        error: (err) => {
                            let msg;
                            try {
                                // try to catch the message from server
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                // controll output message
                                msg = helper.dialogConfig.generalMessages.error;
                            }

                            Swal.fire({
                                title: helper.dialogConfig.headers.errorAtentie,
                                text: msg,
                                icon: 'warning',
                                confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                                showCancelButton: true,
                                cancelButtonText: helper.dialogConfig.buttonLabels.close,
                                reverseButtons: true,
                                allowOutsideClick: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.resendEmail(id);
                                }
                            });
                        }
                    })
            }
        })
    }

    printNotificari() {
        this.isLoading = true;
        const payload = { ...this.dtParameters, selectedRowIds: this.selectedRowIds }

        this.notificariService.printNotificariEmail(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (response: any) => {
                    let dataType = response.type;
                    let binaryData = [];
                    binaryData.push(response);
                    let downloadLink = document.createElement('a');
                    downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
                    downloadLink.setAttribute('target', '_blank');
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
